export default "__VITE_ASSET__Cq$f_L_M__";